module.exports = __webpack_public_path__ + "img/1481894150.bca0273c.jpg";